import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { MdArrowForward, MdArrowBack } from 'react-icons/md';
import { FaRegPlayCircle, FaRegPauseCircle } from 'react-icons/fa';
import { FiCheck } from 'react-icons/fi';

import { formatTime } from '../utils';

const ExerciseControls = ({
  video,
  currentExercise,
  duration,
  currentTime,
  lap,
  reps,
  isCircuitEnd,
  isContentRecommendation,
  changeProgress,
  togglePlay,
  goBack,
  goNext,
}) => {
  const { t } = useTranslation();

  return (
    <footer className="exercises__controls">
      <button disabled={currentExercise < 2} type="button" className="exercises__controls_next back" onClick={goBack}>
        <MdArrowBack />
      </button>
      <button
        disabled={isCircuitEnd && !isContentRecommendation}
        type="button"
        className="exercises__controls_next"
        onClick={goNext}
      >
        {isCircuitEnd ? <FiCheck /> : <MdArrowForward />}
      </button>
      <div className="exercises__progress">
        <button type="button" className="exercises__progress_button" onClick={togglePlay}>
          {video.paused ? <FaRegPlayCircle /> : <FaRegPauseCircle />}
        </button>
        <input
          type="range"
          min="0"
          max={duration}
          step="0.1"
          value={currentTime}
          onChange={changeProgress}
          className="exercise-controls-range exercises__progress_bar"
        />
        <span className="exercises__progress_time">{formatTime(currentTime)}</span>
      </div>
      <section className="exercises__texts">
        <p className="exercises__texts_quantity">{reps}</p>
        <p className="exercises__texts_reps">{t('evieApp.exercises.controls.reps')}</p>
        <div className="exercises__current">
          <p>
            {t('evieApp.exercises.controls.label')} {currentExercise}
          </p>
          <p>
            {t('evieApp.exercises.controls.laps')} {lap}
          </p>
        </div>
      </section>
    </footer>
  );
};

ExerciseControls.propTypes = {
  video: PropTypes.shape({ paused: PropTypes.bool }).isRequired,
  currentExercise: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  currentTime: PropTypes.number.isRequired,
  lap: PropTypes.number.isRequired,
  reps: PropTypes.string.isRequired,
  isCircuitEnd: PropTypes.bool.isRequired,
  isContentRecommendation: PropTypes.bool.isRequired,
  changeProgress: PropTypes.func.isRequired,
  togglePlay: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  goNext: PropTypes.func.isRequired,
};

export default ExerciseControls;
